import { SearchItemPartials } from '@/lib/api/shopware/search/search.types'
import Text from '../../text'
import { normalizeId } from '@/lib/utils/string'

interface SearchResultDetailsProps {
  data: SearchItemPartials
  searchInput: string
}

const boldSearchedInput = (text: string, searchInput: string) => {
  const lowercaseText = text.toLowerCase()
  return lowercaseText.replace(searchInput, `**${searchInput}**`)
}

const SearchResultDetails = ({
  data,
  searchInput,
}: SearchResultDetailsProps) => {
  const name = data.name && boldSearchedInput(data.name, searchInput)
  const subtitle =
    data.subtitle && boldSearchedInput(data.subtitle, searchInput)

  return (
    <div className="flex flex-col gap-1">
      {name && (
        <Text as="span" variant={'secondary'} uppercase markdown>
          {name}
        </Text>
      )}

      {subtitle && (
        <Text
          as="span"
          size={12}
          lineHeight={12}
          className="text-secondary-200"
          uppercase
          markdown
        >
          {subtitle}
        </Text>
      )}

      {normalizeId(data.sapId) && (
        <Text as="p" size={12} lineHeight={15} className="text-secondary-400">
          Item {normalizeId(data.sapId)}
        </Text>
      )}
    </div>
  )
}

export default SearchResultDetails
